import React, {Component} from 'react';
import {setUrlSinglePageApp} from "../functions";

import RedirectOnlyHome from "../common/RedirectOnlyHome";
import {withRouter} from "react-router";
import SearchFormLocalPage from "./SearchFormLocalPage";
import SearchFormInterstatePage from "./SearchFormInterstatePage";
import BookingChoisePage from "./BookingChoisePage";
import SearchResultPage from "./SearchResultPage";
import HireIncludesPage from "./HireIncludesPage";
import BookingDetailsPage from "./BookingDetailsPage";
import BookingDetailsUpdatePage from "./BookingDetailsUpdatePage";
import PaymentPage from "./PaymentPage";
import DonatePage from "./DonatePage";
import BookingSummaryPage from "./BookingSummaryPage";
import BookingSummaryUpdatePage from "./BookingSummaryUpdatePage";
import BookingUpdatePage from "./BookingUpdatePage";
import SuccessPage from "./SuccessPage";
import SuccessPaymentPage from "./SuccessPaymentPage";
import SearchResultInterstatePage from "./SearchResultInterstatePage";
import {getTermsConditions} from "./frontend_script";
import TimerBookingForm from "./TimerBookingForm";
import PaymentOnlyPage from "./PaymentOnlyPage";
import SuccessAlternativePage from "./SuccessAlternativePage";
import PaymentPreparedPage from "./PaymentPreparedPage";
import SuccessPreparedPage from "./SuccessPreparedPage";
import SuccessPageSkipPayment from "./SuccessPageSkipPayment";

// fields from forms, other data set from states
const booking_field_list = {
	get_local_vehicles: ['pickuplocationid', 'pickup_date', 'pickup_time', 'dropofflocationid', 'return_date', 'return_time', 'campaigncode'],
	get_interstate_vehicles: ['pickup_location', 'return_location', 'return_in_different', 'pickup_date', 'pickup_time', 'return_date', 'return_time', 'campaigncode', 'interstate_email', 'interstate_phone'],
	get_rentalcar_prices: ['vehicle'],
	send_quote: ['quote_firstname','quote_lastname','quote_email','quote_phone'],
	error_limit: ['limit_name', 'limit_phone'],
	hire_includes: ['alternative_location', 'alternative_pickupdate', 'alternative_dropoffdate', // эта строка параметров тоже будет выставляться сменой состояний, а не переменными формы
		'premium_insurance', 'additional_drivers', 'roadside_assistance', 'extra_kilometres', 'towing_surcharge', 'pickup_labour_men', 'pickup_labour_hours',
		'return_labour_men', 'return_labour_hours'],
	booking_summary: ['terms_1', 'terms_2', 'terms_3', 'terms_4', 'terms_5'/*, 'terms_6'*/],
	booking_details: ['main_driver_fname', 'main_driver_lname', 'main_driver_email', 'main_driver_phone', 'business_name', 'contact_name', 'contact_email', 'contact_phone', 'contact_address', 'main_driver_dob',
		'main_driver_licenseno', 'main_driver_license_country', 'main_driver_license_expiry', 'main_driver_address', 'main_driver_city', 'main_driver_state', 'main_driver_postcode'],
	payment: ['card_number', 'expiry_month', 'expiry_year', 'security_code', 'customer_fname', 'customer_lname'/*, 'title', 'country'*/],
	payment_send: ['customer_fname', 'customer_lname', 'card_number'],
	totalerror: ['totalerror_name', 'totalerror_phone'],
};

window.onbeforeunload = function (e) {
	window.localStorage.removeItem('start_create_booking');
	window.localStorage.removeItem('end_create_booking');
};

class BookingFormPage extends Component {
	constructor(props) {
		super(props);
		this.handleSetPage = this.handleSetPage.bind(this);
		this.handleSetPage({name: 'online-booking', params: false});

		this.handleSetHire = this.handleSetHire.bind(this);
		this.resetBookingData = this.resetBookingData.bind(this);
		this.handleSetShowData = this.handleSetShowData.bind(this);
		this.handleSetSearchResult = this.handleSetSearchResult.bind(this);
		this.handleSetSearchResultInterstate = this.handleSetSearchResultInterstate.bind(this);
		this.handleSetFilterResult = this.handleSetFilterResult.bind(this);
		this.handleSetFilterResultInterstate = this.handleSetFilterResultInterstate.bind(this);
		this.handleSetHireIncludes = this.handleSetHireIncludes.bind(this);
		this.handleSetBookingFormData = this.handleSetBookingFormData.bind(this);
		this.handleSetBookingSummary = this.handleSetBookingSummary.bind(this);
		this.handleTermsConditions = this.handleTermsConditions.bind(this);
		this.handleSetBookingDetails = this.handleSetBookingDetails.bind(this);
		this.handleSetDonate = this.handleSetDonate.bind(this);
		this.handleSetPayment = this.handleSetPayment.bind(this);
		this.handleSetPayShow = this.handleSetPayShow.bind(this);
		this.handleSetSomeBlock = this.handleSetSomeBlock.bind(this);
		this.handleSetSuccessPage = this.handleSetSuccessPage.bind(this);
		this.handleSetSuccessAlternativesPage = this.handleSetSuccessAlternativesPage.bind(this);
		this.handleSetThankYouConfirm = this.handleSetThankYouConfirm.bind(this);

		this.state = {
			booking_field_list: booking_field_list,
			hire: '',
			show_first_page: true,
			search_form_show: false,
			search_result_show: false,
			search_result_interstate_show: false,
			search_result: {
				'success': 0,
				'vehicles': {},
				'vehicles_closest': {},
				'vehicles_closest_date': {},
				'error_limit': 0
			},
			search_result_filter: {
				'vehicles': {},
				'vehicles_closest': {},
				'vehicles_closest_date': {}
			},
			category_group_filter: 0,
			hire_includes_show: false,
			booking_summary_show: false,
			booking_details_show: false,
			payment_show: false,
			donate_show: false,
			success_show: false,
			booking_form_data: { //here save all booking data from all components
				booking: {},
				payment: {},
				driver_license_images: {},
				additional_drivers: {},
				signature_json: "{\"lines\":[]}",
				signature_png: "",
				vehicle_name: "",
				submit: "",
				donation_count: 0
			},
			get_total_result: {}, // back string with all table
			to_show: {}, // show data on pages: kms and etc.
			reset_photo_fields: false,
			scroll_to_element: '', // if empty, then not scroll (after every scroll need set empty)
			mini_form_data: (window.mini_form_data !== undefined && window.mini_form_data == true) ? true : false,
			update_process: false,
			summary_page_info: {
				booking: {},
				html: {},
				main_driver: {},
				additional_drivers: {},
				prepared:{}
			},
			payment_process: false,
			payment_amount: {}
		};

		setUrlSinglePageApp(this.props.history.location.pathname);
	}

	componentDidMount() {
		if (window.bf_update_process == true && window.is_alternatives) {
			this.setState({update_process: window.bf_update_process, show_first_page: false, booking_summary_show: true, summary_page_info: window.bf_summary_page_info, is_alternative:window.is_alternatives, alternatives:window.bf_form_data.alternatives});
		}
		else
			if (window.bf_update_process == true) {
				const prepared = window.bf_summary_page_info && window.bf_summary_page_info.prepared?window.bf_summary_page_info.prepared: [];
				const prep_is_extradriver = prepared && prepared.is_extradriver;
				const prep_extradrivers = prepared && prepared.formdata && prepared.formdata.booking_options && prepared.formdata.booking_options.extradriver ? prepared.formdata.booking_options.extradriver.length : 0;
				this.setState({update_process: window.bf_update_process, show_first_page: false, booking_summary_show: true, summary_page_info: window.bf_summary_page_info, payment_amount: window.bf_payment_amount, prep_is_extradriver:prep_is_extradriver,prep_extradrivers:prep_extradrivers});
			}
			else
				if (window.bf_payment_process == true) {
					this.setState({payment_process: window.bf_payment_process, show_first_page: false, payment_show: true, payment_amount: window.bf_payment_amount});
				}
				else {
					if (['local', 'interstate'].includes(window.mini_form_hire)) {
						if (window.mini_form_submit == true) {
							this.handleSetHire(window.mini_form_hire);
						}
						else
							if (window.mini_form_data == true || window.bf_external_promo == true) {
								this.handleSetBookingFormData(window.bf_form_data, {}, {}, {});
								this.setState({search_form_show: true, hire: window.mini_form_hire});
							}
					}
				}
		getTermsConditions();
	}

	componentWillUnmount() {
		window.localStorage.removeItem('start_create_booking');
		window.localStorage.removeItem('end_create_booking');
		if (typeof window.stopBooking === 'function')
			window.stopBooking();
	}

	handleSetPage(options) {
		if (options.name == 'online-booking')
		  this.props.handleSetPage(options);
	}

	resetBookingData(hire) {
		let booking_form_data = {
			booking: {
				hire:hire,
				billing_details_different: 0
			},
			payment: {},
			driver_license_images: {},
			additional_drivers: {},
			signature_json: "{\"lines\":[]}",
			signature_png: "",
			vehicle_name: "",
			submit: "",
			donation_count: 0
		};
		this.setState({
			show_first_page: true,
			hire: hire,
			search_form_show: hire !== '' ? true : false,
			search_result_show: false,
			search_result_interstate_show: false,
			hire_includes_show: false,
			booking_form_data: booking_form_data,
			search_result: {
				'success': 0,
				'vehicles': {},
				'vehicles_closest': {},
				'vehicles_closest_date': {},
				'error_limit': 0
			},
			search_result_filter: {
				'vehicles': {},
				'vehicles_closest': {},
				'vehicles_closest_date': {}
			},
			category_group_filter: 0,
			booking_summary_show: false,
			booking_details_show: false,
			payment_show: false,
			donate_show: false,
			mini_form_data: false,

		});
	}

	handleSetHire(hire) {
		let booking_form_data = {
			booking: {
				hire:hire,
				billing_details_different: 0
			},
			payment: {},
			driver_license_images: {},
			additional_drivers: {},
			signature_json: "{\"lines\":[]}",
			signature_png: "",
			vehicle_name: "",
			submit: "",
			donation_count: 0
		};

		this.setState({hire: hire, search_form_show: true, search_result_show: false, search_result_interstate_show: false, hire_includes_show: false, booking_form_data: booking_form_data, mini_form_data: false});
//		console.log('handleSetHire', hire);
	}

	handleSetThankYouConfirm() {
		this.handleSetSuccessPage();
	}

	handleSetSearchResult(search_result_show, hire_includes_show, search_result, search_result_filter, category_group_filter) {
		this.setState({search_result_show: search_result_show, hire_includes_show: hire_includes_show, search_result: search_result, search_result_filter: search_result_filter, category_group_filter: category_group_filter});
		//console.log('handleSetSearchResult', search_result, search_result_filter, category_group_filter);
	}

	handleSetSuccessAlternativesPage(messages) {
		this.setState({ success_show: true, search_result: {}, search_result_filter: {}, alternatives:[], summary_page_info: {}, messages:messages });
	}

	handleSetSuccessPage() {
		this.setState({ success_show: true, search_result: {}, search_result_filter: {}, alternatives:[], summary_page_info: {} });
	}

	handleSetFilterResult(search_result_show, hire_includes_show, search_result_filter, category_group_filter) {
		this.setState({search_result_show: search_result_show, hire_includes_show: hire_includes_show, search_result_filter: search_result_filter, category_group_filter: category_group_filter});
		//console.log('handleSetFilterResult', search_result_filter, category_group_filter);
	}

	handleSetSearchResultInterstate(search_result_interstate_show, hire_includes_show, search_result, search_result_filter, category_group_filter) {
		this.setState({search_result_interstate_show: search_result_interstate_show, hire_includes_show: hire_includes_show, search_result: search_result, search_result_filter: search_result_filter, category_group_filter: category_group_filter});
		//console.log('handleSetSearchResultInterstate', search_result, search_result_filter, category_group_filter);
	}

	handleSetFilterResultInterstate(search_result_interstate_show, hire_includes_show, search_result_filter, category_group_filter) {
		this.setState({search_result_interstate_show: search_result_interstate_show, hire_includes_show: hire_includes_show, search_result_filter: search_result_filter, category_group_filter: category_group_filter});
		//console.log('handleSetFilterResultInterstate', search_result_filter, category_group_filter);
	}

	handleSetShowData(to_show) {
		let show_data = this.state.to_show;
		Object.keys(to_show).map((k) => {
			show_data[k] = to_show[k];
		});
		this.setState({to_show: show_data});
	}

	handleResetVehicles = () => {
		let booking_data = this.state.booking_form_data;
		booking_data.booking.vehicle = '';
		booking_data.booking.alternative_location = '';
		booking_data.booking.alternative_pickupdate = '';
		booking_data.booking.alternative_dropoffdate = '';
		booking_data.vehicle_name = '';
		booking_data.booking.vehicle_payment = false;
		this.setState({booking_form_data:booking_data});
	}

	handleSetHireIncludes(selected_vehicle, selected_vehicle_name, alternative_location = '', alternative_pickupdate = '', alternative_dropoffdate = '', vehicle_payment = false) {
		let booking_data = this.state.booking_form_data;
		booking_data.booking.vehicle = selected_vehicle;
		booking_data.booking.alternative_location = alternative_location;
		booking_data.booking.alternative_pickupdate = alternative_pickupdate;
		booking_data.booking.alternative_dropoffdate = alternative_dropoffdate;
		booking_data.vehicle_name = selected_vehicle_name;
		booking_data.booking.vehicle_payment = vehicle_payment;
		this.setState({hire_includes_show:true, booking_form_data:booking_data});
	}

	handleSetBookingFormData(booking, driver_license_images, payment, data) {
		let booking_data = this.state.booking_form_data;

		Object.keys(booking).map((k) => {
			booking_data.booking[k] = booking[k];
		});
		Object.keys(driver_license_images).map((k) => {
			booking_data.driver_license_images[k] = driver_license_images[k];
		});
		Object.keys(payment).map((k) => {
			booking_data.payment[k] = payment[k];
		});
		Object.keys(data).map((k) => {
			booking_data[k] = data[k];
		});
		if (booking.location_group != undefined)
			booking_data['location_group'] = booking.location_group;

		this.setState({booking_form_data: booking_data});
		//console.log('handleSetBookingFormData', this.state.booking_form_data);
	}

	handleSetBookingSummary(booking_summary_show, show_first_page, search_form_show, search_result_show, search_result_interstate_show, hire_includes_show, get_total_result) {
		this.setState({booking_summary_show: booking_summary_show, show_first_page: show_first_page, search_form_show: search_form_show, search_result_show: search_result_show, search_result_interstate_show: search_result_interstate_show, hire_includes_show: hire_includes_show, get_total_result: get_total_result});
	}

	handleTermsConditions(signature_json, signature_png, terms_1, terms_2, terms_3, terms_4, terms_5/*, terms_6*/, status) {
		let booking_data = this.state.booking_form_data;

		booking_data.signature_json = signature_json;
		booking_data.signature_png = signature_png;
		booking_data.booking.terms_1 = terms_1;
		booking_data.booking.terms_2 = terms_2;
		booking_data.booking.terms_3 = terms_3;
		booking_data.booking.terms_4 = terms_4;
		booking_data.booking.terms_5 = terms_5;
//		booking_data.booking.terms_6 = terms_6;
		booking_data.booking.status = status;

		this.setState({booking_details_show: true, booking_form_data: booking_data});
		//console.log('handleTermsConditions', signature_json, signature_png, this.state.booking_form_data);
	}

	handleSetBookingDetails(donate_show, booking, driver_license_images, additional_drivers) {
		let booking_data = this.state.booking_form_data;

		booking_data.booking = booking;
		booking_data.driver_license_images = driver_license_images;
		booking_data.additional_drivers = additional_drivers;

		this.setState({donate_show: donate_show, booking_form_data: booking_data});
		//console.log('handleSetBookingDetails', this.state.booking_form_data);
	}

	handleSetPayShow() {
		this.setState({payment_show: true, donate_show: false});
	}

	handleSetDonate(disability, donation_count) {
		let booking_data = this.state.booking_form_data;

		booking_data.submit = disability;
		booking_data.donation_count = donation_count;

		if (this.state.booking_form_data.booking.vehicle_payment === true)
			this.setState({success_show: true, booking_form_data: booking_data, booking_summary_show: false, booking_details_show: false, donate_show: false});
		else
			this.setState({payment_show: true, booking_form_data: booking_data, donate_show: false});
		//console.log('handleSetDonate', disability);
	}

	handleSetPayment(booking_summary_show, booking_details_show, donate_show, payment_show, payment_data, success_show) {
		let booking_data = this.state.booking_form_data;

		booking_data.payment = payment_data;

		this.setState({booking_summary_show: booking_summary_show, booking_details_show: booking_details_show, donate_show: donate_show, payment_show: payment_show, booking_form_data: booking_data, success_show: success_show});
		//console.log('handleSetPayment', payment_show, donate_show, booking_data, success_show);
	}

	handleSetSomeBlock(block_name, block_value) {
		this.setState({[block_name]: block_value});
		//console.log('handleSetSomeBlock', block_name, block_value);
	}

	render() {
		return (<>
			<RedirectOnlyHome />

			<div className="timer_booking_end_wrap">
				<TimerBookingForm
					hire={this.state.hire}
					resetBookingData={this.resetBookingData}/>
			</div>

			<div className={'value-space'}>
				<div className="booking-form-container" id={'booking-form'}>
					{
						this.state.show_first_page &&
							<BookingChoisePage
								hire={this.state.hire}
								handleSetHire={this.handleSetHire}
								handleSetSomeBlock={this.handleSetSomeBlock}
						/>
					}
					{
						this.state.search_form_show &&
							(
								this.state.booking_form_data.booking.hire === 'local' ?
								<SearchFormLocalPage
									booking_field_list={this.state.booking_field_list}
									booking_form_data={this.state.booking_form_data}
									scroll_to_element={this.state.scroll_to_element}
									category_group_filter={this.state.category_group_filter}
									handleSetSearchResult={this.handleSetSearchResult}
									handleSetBookingFormData={this.handleSetBookingFormData}
									handleSetShowData={this.handleSetShowData}
									handleSetSomeBlock={this.handleSetSomeBlock}
									mini_form_data={this.state.mini_form_data}
									handleResetVehicles={this.handleResetVehicles}
							/> :
							<SearchFormInterstatePage
								booking_field_list={this.state.booking_field_list}
								booking_form_data={this.state.booking_form_data}
								scroll_to_element={this.state.scroll_to_element}
								category_group_filter={this.state.category_group_filter}
								handleSetSearchResultInterstate={this.handleSetSearchResultInterstate}
								handleSetBookingFormData={this.handleSetBookingFormData}
								handleSetShowData={this.handleSetShowData}
								handleSetSomeBlock={this.handleSetSomeBlock}
								mini_form_data={this.state.mini_form_data}
								handleResetVehicles={this.handleResetVehicles}
							/>
							)

					}
					{
						this.state.search_result_show &&
							<SearchResultPage
								search_result={this.state.search_result}
								search_result_filter={this.state.search_result_filter}
								booking_field_list={this.state.booking_field_list}
								booking_form_data={this.state.booking_form_data}
								to_show={this.state.to_show}
								scroll_to_element={this.state.scroll_to_element}
								category_group_filter={this.state.category_group_filter}
								handleSetHireIncludes={this.handleSetHireIncludes}
								handleSetShowData={this.handleSetShowData}
								handleSetSomeBlock={this.handleSetSomeBlock}
								handleSetFilterResult={this.handleSetFilterResult}
							/>
					}
					{
						this.state.search_result_interstate_show &&
							<SearchResultInterstatePage
								search_result={this.state.search_result}
								search_result_filter={this.state.search_result_filter}
								booking_field_list={this.state.booking_field_list}
								booking_form_data={this.state.booking_form_data}
								to_show={this.state.to_show}
								scroll_to_element={this.state.scroll_to_element}
								category_group_filter={this.state.category_group_filter}
								handleSetHireIncludes={this.handleSetHireIncludes}
								handleSetShowData={this.handleSetShowData}
								handleSetSomeBlock={this.handleSetSomeBlock}
								handleSetFilterResultInterstate={this.handleSetFilterResultInterstate}
							/>
					}
					{
						this.state.hire_includes_show &&
							<HireIncludesPage
								booking_field_list={this.state.booking_field_list}
								booking_form_data={this.state.booking_form_data}
								to_show={this.state.to_show}
								scroll_to_element={this.state.scroll_to_element}
								handleSetBookingSummary={this.handleSetBookingSummary}
								handleSetBookingFormData={this.handleSetBookingFormData}
								handleSetSomeBlock={this.handleSetSomeBlock}
							/>
					}
					{
						(this.state.booking_summary_show && !this.state.update_process) &&
							<BookingSummaryPage
								booking_field_list={this.state.booking_field_list}
								booking_form_data={this.state.booking_form_data}
								get_total_result={this.state.get_total_result}
								to_show={this.state.to_show}
								scroll_to_element={this.state.scroll_to_element}
								handleSetBookingSummary={this.handleSetBookingSummary}
								handleTermsConditions={this.handleTermsConditions}
								handleSetShowData={this.handleSetShowData}
								handleSetSomeBlock={this.handleSetSomeBlock}
								handleSetBookingFormData={this.handleSetBookingFormData}
							/>
					}
					{
						( !this.state.success_show && this.state.booking_summary_show && this.state.update_process  && !this.state.is_alternative) &&
							<BookingSummaryUpdatePage
								booking_field_list={this.state.booking_field_list}
								scroll_to_element={this.state.scroll_to_element}
								summary_page_info={this.state.summary_page_info}
								handleTermsConditions={this.handleTermsConditions}
								handleSetSomeBlock={this.handleSetSomeBlock}
							/>
					}
					{
						( this.state.booking_summary_show && this.state.update_process && !this.state.success_show && this.state.is_alternative ) &&
						<BookingUpdatePage
							booking_field_list={this.state.booking_field_list}
							scroll_to_element={this.state.scroll_to_element}
							summary_page_info={this.state.summary_page_info}
							handleSetSomeBlock={this.handleSetSomeBlock}
							alternatives = {this.state.alternatives}
							handleSetSuccessPage = {this.handleSetSuccessAlternativesPage}
						/>
					}


					{
						(this.state.booking_details_show && !this.state.update_process) &&
							<BookingDetailsPage
								booking_field_list={this.state.booking_field_list}
								booking_form_data={this.state.booking_form_data}
								reset_photo_fields={this.state.reset_photo_fields}
								payment_show={this.state.payment_show}
								scroll_to_element={this.state.scroll_to_element}
								handleSetBookingDetails={this.handleSetBookingDetails}
								handleSetSomeBlock={this.handleSetSomeBlock}
								handleSetBookingSummary={this.handleSetBookingSummary}
							/>
					}
					{
						(  !this.state.success_show && this.state.booking_details_show && this.state.update_process && !this.state.is_alternative) &&
						<BookingDetailsUpdatePage
							booking_field_list={this.state.booking_field_list}
							booking_form_data={this.state.booking_form_data}
							reset_photo_fields={this.state.reset_photo_fields}
							scroll_to_element={this.state.scroll_to_element}
							booking_info={this.state.summary_page_info}
							main_driver={ this.state.summary_page_info.prepared && this.state.summary_page_info.prepared.formdata ? this.state.summary_page_info.prepared.formdata.booking_options.customer : []}
							additional_drivers={ this.state.summary_page_info.prepared && this.state.summary_page_info.prepared.formdata ?  this.state.summary_page_info.prepared.formdata.booking_options.extradrivers : []}
							payment_show={this.state.payment_show}
							handleSetPayShow={this.handleSetPayShow}
							handleSetSomeBlock={this.handleSetSomeBlock}
							handleSetShowData={this.handleSetShowData}
							handleSetBookingDetails={this.handleSetBookingDetails}
							handleSetBookingSummary={this.handleSetBookingSummary}
							handleSetThankYouConfirm={this.handleSetThankYouConfirm}
						/>
					}
					{
						this.state.donate_show && !this.state.update_process &&
							<DonatePage
								booking_form_data={this.state.booking_form_data}
								scroll_to_element={this.state.scroll_to_element}
								handleSetDonate={this.handleSetDonate}
								handleSetShowData={this.handleSetShowData}
								handleSetSomeBlock={this.handleSetSomeBlock}
							/>
					}
					{
						(this.state.payment_show && this.state.update_process && !this.state.payment_process) &&
						<PaymentPreparedPage
							payment_amount={this.state.payment_amount}
							booking_field_list={this.state.booking_field_list}
							booking_form_data={this.state.booking_form_data}
							scroll_to_element={this.state.scroll_to_element}
							handleSetPayment={this.handleSetPayment}
							handleSetSomeBlock={this.handleSetSomeBlock}
							resetBookingData={this.resetBookingData}
						/>
					}
					{
						(this.state.payment_show && !this.state.update_process && !this.state.payment_process) &&
							<PaymentPage
								to_show={this.state.to_show}
								booking_field_list={this.state.booking_field_list}
								booking_form_data={this.state.booking_form_data}
								scroll_to_element={this.state.scroll_to_element}
								handleSetPayment={this.handleSetPayment}
								handleSetSomeBlock={this.handleSetSomeBlock}
								resetBookingData={this.resetBookingData}
							/>
					}
					{
						(this.state.payment_show && !this.state.update_process && this.state.payment_process) &&
							<PaymentOnlyPage
								payment_amount={this.state.payment_amount}
								booking_field_list={this.state.booking_field_list}
								scroll_to_element={this.state.scroll_to_element}
								handleSetSomeBlock={this.handleSetSomeBlock}
							/>
					}

					{
						(this.state.success_show && !this.state.payment_process  && !this.state.is_alternative && !this.state.update_process  && this.state.booking_form_data.booking.vehicle_payment === false ) &&
							<SuccessPage />
					}
					{
						(this.state.success_show && !this.state.payment_process  && !this.state.is_alternative && !this.state.update_process && this.state.booking_form_data.booking.vehicle_payment === true ) &&
							<SuccessPageSkipPayment />
					}
					{
						(this.state.success_show && !this.state.payment_process  && !this.state.is_alternative && this.state.update_process ) &&
						<SuccessPreparedPage
							extradriver = {this.state.prep_is_extradriver}
							additional_drivers={this.state.prep_extradrivers}
						/>
					}
					{
						(this.state.success_show && this.state.payment_process && !this.state.is_alternative) &&
							<SuccessPaymentPage />
					}
					{
						(this.state.success_show && this.state.is_alternative) &&
						<SuccessAlternativePage
							msg = {this.state.messages}
						/>
					}
				</div>
			</div>
		</>);
	}
}

const BookingFormPageR = withRouter(BookingFormPage);
export default BookingFormPageR;
